/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{__decorate as o}from"tslib";import{uniform as r,UniformGroup as p}from"../../GraphShaderModule.js";import{Vec2 as s}from"../../graph/glsl.js";class t extends p{}o([r(s)],t.prototype,"size",void 0);export{t as MosaicInfo};
